import { Enum2Options } from "../../../../../src/demos/enum2options";
import * as React from 'react';
export default {
  Enum2Options,
  React
};